export default __webpack_public_path__ + "static/media/eclipse4.e2d06596.svg";